import React from 'react';
import StatusIndicator from '@creditflowresearch/uilib/StatusIndicator';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import capitalize from '@framework/data-helpers/string/capitalize';

import styles from './styles.module.scss';

const StatusCell = ({
  content = null,
  cellData,
}) => (
  <Tooltip
    placement="bottom"
    content={ content || capitalize(cellData) }
  >
    <StatusIndicator
      className={ styles.statusIndicator }
      status={ cellData }
    />
  </Tooltip>
);

export default StatusCell;
